import { SuspensePage } from '@/shared/ui/layout/SuspensePage';
import { PagesNotFoundMain } from './modules/ui/Main';

const NotFoundPage = (
  <SuspensePage>
    <PagesNotFoundMain />
  </SuspensePage>
);

export default NotFoundPage;
